import { render, staticRenderFns } from "./ProfileProgressSection.vue?vue&type=template&id=0f8bca5b&scoped=true&"
import script from "./ProfileProgressSection.vue?vue&type=script&lang=js&"
export * from "./ProfileProgressSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileProgressSection.vue?vue&type=style&index=0&id=0f8bca5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bca5b",
  null
  
)

export default component.exports